/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ApplicationView } from '@gh/builder-shared-data';
import { API_SB_URL, CONTEXT_PATH } from '@gh/config';
import { isNotNil } from '@gh/core-util';

const APP_VIEW_RE = new RegExp(`^(${CONTEXT_PATH}(sandbox/?)?)((office-view|master-view)/([^/?]+)(/|\\?)?)?`);
const SANDBOX = 2;
const APP_VIEW_INDEX = 4;
const APP_VIEW_ID_INDEX = 5;

export interface BootstrapParams {
  baseUrl: string;
  path: string;
  query: string;
  sandbox: boolean;
  sandboxUrl: string;
  appView?: string;
  appViewId?: string;
}

export function getBuilderBootstrapParams(): BootstrapParams {
  const routeMatch = APP_VIEW_RE.exec(location.pathname);

  const sandbox = isNotNil(routeMatch && routeMatch[SANDBOX]);
  const sandboxUrl = isNotNil(routeMatch && routeMatch[SANDBOX]) ? API_SB_URL : '';
  const baseUrl = routeMatch ? routeMatch[0] : CONTEXT_PATH;
  const appView = routeMatch ? {
    'office-view': ApplicationView.Office,
    'master-view': ApplicationView.Master,
  }[routeMatch[APP_VIEW_INDEX]] : void 0;
  const appViewId = routeMatch ? routeMatch[APP_VIEW_ID_INDEX] : void 0;

  return {
    baseUrl,
    path: location.pathname.substring(baseUrl.length),
    query: location.search,
    sandbox,
    sandboxUrl,
    appView,
    appViewId,
  };
}
